import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgBtc48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#E7E7E7",
  d: "M11.973 21.984c5.49-.01 9.932-4.487 9.923-10-.01-5.514-4.467-9.976-9.956-9.967-5.49.009-9.933 4.486-9.923 10 .009 5.513 4.466 9.976 9.956 9.967Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7931A",
  d: "M11.973 21.984c5.49-.01 9.932-4.487 9.923-10-.01-5.514-4.467-9.976-9.956-9.967-5.49.009-9.933 4.486-9.923 10 .009 5.513 4.466 9.976 9.956 9.967"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.713 10.758c.2-1.331-.813-2.047-2.2-2.522l.45-1.803-1.097-.275-.438 1.756c-.288-.072-.585-.14-.878-.206l.44-1.766-1.097-.275-.45 1.803a33 33 0 0 1-.7-.165v-.006L9.23 6.92l-.29 1.172s.815.188.797.197c.444.11.525.406.512.638l-.512 2.053c.031.01.072.018.115.037l-.115-.028-.72 2.878c-.052.135-.193.338-.502.26.009.015-.797-.2-.797-.2l-.544 1.256 1.428.356c.266.066.525.138.782.203l-.454 1.822 1.097.275.45-1.803q.45.12.876.228l-.457 1.794 1.097.275.454-1.819c1.872.353 3.278.213 3.869-1.481.478-1.363-.025-2.15-1.01-2.663.722-.165 1.26-.637 1.407-1.612m-2.51 3.516c-.337 1.362-2.635.625-3.379.44l.604-2.415c.747.187 3.131.553 2.775 1.975m.34-3.535c-.309 1.24-2.218.61-2.837.456l.547-2.19c.619.153 2.613.44 2.29 1.734"
}));

export { SvgBtc48Rounded as default };
//# sourceMappingURL=Btc48Rounded.js.map
